import * as Sentry from '@sentry/browser'
import {
  denyUrls,
  ignoreErrors
} from 'components/InitializeSentry/ignorePatterns'

Sentry.init({
  dsn: process.env.NEXT_PUBLIC_SENTRY_DSN,
  integrations: [Sentry.featureFlagsIntegration()],
  environment: process.env.NEXT_PUBLIC_ENV,
  release: process.env.NEXT_PUBLIC_APP_VERSION,
  denyUrls,
  ignoreErrors
})

// Shared code in @vio/core reports through a bare global `Sentry`, which used
// to be the CDN bundle loaded from _document. Re-expose the two methods it
// calls so those call sites keep reporting now that the CDN script is gone.
;(
  globalThis as unknown as {
    Sentry: Pick<typeof Sentry, 'captureException' | 'captureMessage'>
  }
).Sentry = {
  captureException: Sentry.captureException,
  captureMessage: Sentry.captureMessage
}
